import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionLabelProps {
    index: string
    children: ReactNode
    className?: string
}

const SectionLabel: FC<SectionLabelProps> = ({ index, children, className }): ReactNode => {
    return (
        <p className={cn('flex items-center gap-3 font-mono text-xs font-medium tracking-[0.2em] uppercase', className)}>
            <span className='inline-flex h-7 min-w-7 items-center justify-center rounded-full border border-current px-2 tracking-normal'>
                {index}
            </span>

            {children}
        </p>
    )
}

export default SectionLabel
